import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import TranscriptFiltersDialog from "./TranscriptFiltersDialog";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import FilterChipDisplay from "../../FilterChipDisplay";

interface ITranscriptFiltersProps {
    isAgent: boolean
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function TranscriptFilters({ isAgent, callTableViewModel, setCallTableViewModel }: ITranscriptFiltersProps) {
    const [open, setOpen] = useState(false);

    const text =
        <Typography variant="body1">
            {
                callTableViewModel.filters.transcriptFilters.transcriptMode ? `${callTableViewModel.filters.transcriptFilters.transcriptMode}` : ''
            }
            {
                callTableViewModel.filters.transcriptFilters.searchMode ? ` - ${callTableViewModel.filters.transcriptFilters.searchMode}` : ''
            }
            {
                callTableViewModel.filters.transcriptFilters.searchValues ? ` - ${callTableViewModel.filters.transcriptFilters.searchValues}` : ''
            }
        </Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable={!isAgent}
                onClick={() => setOpen(true)} />
            <TranscriptFiltersDialog
                open={open}
                setOpen={setOpen}
                callTableViewModel={callTableViewModel}
                setCallTableViewModel={setCallTableViewModel} />
        </>
    )
}